import { render, staticRenderFns } from "./LgNumber.vue?vue&type=template&id=14791de2"
import script from "./LgNumber.vue?vue&type=script&lang=js"
export * from "./LgNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports